<template>
  <v-row class="dash-kpis">
    <v-col cols="12" sm="6" md="3">
      <v-card class="kpi" elevation="0" to="/users">
        <div class="kpi__icon kpi__icon--teal"><v-icon dark>mdi-account-group</v-icon></div>
        <div class="kpi__body">
          <div class="kpi__value">{{ fmt(counts.totalUser) }}</div>
          <div class="kpi__label">Candidates</div>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card class="kpi" elevation="0" to="/teacher">
        <div class="kpi__icon kpi__icon--navy"><v-icon dark>mdi-school</v-icon></div>
        <div class="kpi__body">
          <div class="kpi__value">{{ fmt(counts.totalTeacher) }}</div>
          <div class="kpi__label">Teachers</div>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card class="kpi" elevation="0" to="/course">
        <div class="kpi__icon kpi__icon--brass"><v-icon dark>mdi-book-open-variant</v-icon></div>
        <div class="kpi__body">
          <div class="kpi__value">{{ fmt(counts.totalCourse) }}</div>
          <div class="kpi__label">Courses</div>
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card class="kpi" elevation="0">
        <div class="kpi__icon kpi__icon--green"><v-icon dark>mdi-certificate</v-icon></div>
        <div class="kpi__body">
          <div class="kpi__value">{{ fmt(counts.totalCourseCompletedCandidate) }}</div>
          <div class="kpi__label">Completed courses</div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "SACounts",
  data() {
    return {
      counts: {},
      roleId: "",
      current_date: new Date(),
      current_month: new Date(),
    };
  },
  mounted() {
    this.getData();
    this.getCurrentDate();
    this.roleId = this.user.roles[0].id;
  },
  methods: {
    // Format a count for display: thousands separators, and a dash while loading.
    fmt(v) {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      return isNaN(n) ? String(v) : n.toLocaleString();
    },
    async getData() {
      try {
        let query = (this.roleId = this.roleId ? this.roleId : "");
        let response = await axios.get(`/admin_dashboard?${query}`);
        this.counts = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      this.current_date = `${year}-${month}-${day}`;
      this.current_month = `${month}`;
    },
  },
};
</script>

<style scoped>
.dash-kpis { margin: 0 -8px; }

.kpi {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 20px;
  border-radius: 14px !important;
  border: 1px solid #dbe3e8;
  background: #ffffff;
  transition: transform .18s ease, box-shadow .25s ease;
}
.kpi:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(19,36,48,.10) !important; }

.kpi__icon {
  flex: 0 0 auto;
  width: 54px;
  height: 54px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.kpi__icon .v-icon { font-size: 28px; }
.kpi__icon--teal  { background: linear-gradient(135deg, #0E8390, #0aa0a0); }
.kpi__icon--navy  { background: linear-gradient(135deg, #0C3A5B, #12557E); }
.kpi__icon--brass { background: linear-gradient(135deg, #D69A34, #e3b45f); }
.kpi__icon--green { background: linear-gradient(135deg, #2E8B6F, #37a884); }

.kpi__value {
  font-family: 'Bahnschrift', 'Segoe UI', system-ui, sans-serif;
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.1;
  color: #0c3a5b;
  font-variant-numeric: tabular-nums;
}
.kpi__label {
  font-size: 0.78rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #61798a;
  margin-top: 2px;
}
</style>
